import { render, staticRenderFns } from "./DirectivesList.vue?vue&type=template&id=7b426a3b"
import script from "./DirectivesList.vue?vue&type=script&lang=js"
export * from "./DirectivesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports